import { gql } from "@apollo/client";

export const GET_ALL_NOTIFICATIONS = gql`
query GetAllNotificationsRI($idDelegacion: Int!, $tipoNotificacionFiltro: TipoNotificacionAsistencialFiltro!, $idEstadoValidacion: Int!, $from: CustomDateTime!, $to: CustomDateTime!) {
    allNotificationsRI(idDelegacion: $idDelegacion, tipoNotificacionFiltro: $tipoNotificacionFiltro,
        idEstadoValidacion: $idEstadoValidacion, from: $from, to: $to) {
        success
        error
        valorEsperado {
            idEvaluacion
            idControlRI
            idDatosGenerales
            tipoNoticacion
            delegacion
            tipoEvaluacion
            idTipoModulo
            programa
            codSap
            cliente
            hC
            paciente
            estadoValidacion
            idMotivoNoIngreso
            motivoNoIngreso
            idMotivoRechazo
            motivoRechazo
            estadoRI
            estadoCoordinador
            profesionalASignado
            fechaLimite
            fechaRealizacion
            idMisTareas
            direccionRI
            observaciones
            franjaEtaria
            numeroDocumento
            fechaNacimiento
            edad
            telefonoContacto
            familiar
            familiarTelefono
            rI
        }
    }
}`;